import { Disclosure } from "@headlessui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import imageFaq from "../../assets/images/all-img/Customer-Questions.webp";

const Accordion = () => {
  const { t } = useTranslation(); // Initialize translation

  // FAQ Items
  const faqs = [
    { key: "assessment" },
    { key: "tools_online_learning" },
    { key: "track_progress" },
    { key: "emergency_lessons" },
  ];

  return (
    <div className="section-padding bg-white mt-5 mb-5 bg-[url('../images/all-img/section-bg-15.png')] bg-bottom bg-cover bg-no-repeat">
      <div className="container">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-[30px]">
          {/* Left Side: FAQ Content */}
          <div>
            <div className="mini-title">{t("faq.mini_title")}</div>
            <div className="column-title">{t("faq.title")}</div>

            <ul className="list accrodains space-y-[30px] lg:max-w-[470px]">
              {faqs.map((faqItem, index) => (
                <Disclosure key={index}>
                  {({ open }) => (
                    <li className={open ? "open" : null}>
                      <Disclosure.Button
                        type="button"
                        className="accrodain-button"
                      >
                        <span>{t(`faq.${faqItem.key}.question`)}</span>
                        <span className="icon-pm"></span>
                      </Disclosure.Button>

                      <Disclosure.Panel className="content">
                        {t(`faq.${faqItem.key}.answer`)}
                      </Disclosure.Panel>
                    </li>
                  )}
                </Disclosure>
              ))}
            </ul>
          </div>

          {/* Right Side: Image */}
          <div>
            <img src={imageFaq} alt="FAQ" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
